import React, { useState } from 'react'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { Visibility } from '@material-ui/icons'
import {
   makeStyles,
   FormControl,
   InputAdornment,
   IconButton,
   TextField
} from '@material-ui/core'

const usePasswordFieldStyles = makeStyles(theme => ({
   inputIcon: {
      marginRight: theme.spacing(-1)
   }
}))

function PasswordField({
   fieldLabel,
   fieldName,
   formValue,
   handleChange,
   fieldInvalid,
   errorMessage
}) {
   const classes = usePasswordFieldStyles()

   const [showPassword, setShowPassword] = useState(false)

   function handleClickShowPassword() {
      setShowPassword(previous => !previous)
   }

   function handleMouseDownPassword(event) {
      event.preventDefault()
   }

   return (
      <FormControl fullWidth>
         <TextField
            error={fieldInvalid}
            value={formValue}
            onChange={handleChange}
            type={showPassword ? 'text' : 'password'}
            InputProps={{
               onCopy: e => e.preventDefault(),
               onPaste: e => e.preventDefault(),
               endAdornment: (
                  <InputAdornment className={classes.inputIcon} size="small">
                     <IconButton
                        aria-label="Cambiar visibilidad de la contraseña"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        size="small"
                     >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                     </IconButton>
                  </InputAdornment>
               )
            }}
            label={fieldLabel || 'Contraseña *'}
            name={fieldName || 'password'}
            helperText={errorMessage}
            variant="outlined"
            size="small"
            margin="normal"
         />
      </FormControl>
   )
}

export default PasswordField
